import { createContext } from '@wordpress/element';
export const TooltipInternalContext = createContext({
  isNestedInTooltip: false
});
TooltipInternalContext.displayName = 'TooltipInternalContext';